import { z } from "zod/v4";
import {
	type SubmitSamsReport,
	samsLandesverbandSchema,
	samsSubmissionSchema,
} from "../schemas/sams";
import { fetchApi } from "./internal";

// DVV/SAMS result reporting (Rust `onsand-sams`, routes under /sams). Admin-gated.
export const sams = {
	landesverbaende: () => fetchApi("/sams/landesverbaende", z.array(samsLandesverbandSchema)),
	reports: (tournamentId: string) =>
		fetchApi(
			`/sams/reports?tournamentId=${encodeURIComponent(tournamentId)}`,
			z.array(samsSubmissionSchema),
		),
	report: (id: string) => fetchApi(`/sams/reports/${id}`, samsSubmissionSchema),
	submit: (data: SubmitSamsReport) =>
		fetchApi("/sams/reports", samsSubmissionSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
};
